import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { SupportWidgetComponent } from './support-widget.component'

export { SupportWidgetComponent } from './support-widget.component'

@NgModule({
  imports: [CommonModule],
  declarations: [SupportWidgetComponent],
  exports: [SupportWidgetComponent],
})
export class SupportWidgetModule {}
